<template src="./index.html">
</template>
<script>
import pzwd from './pzwd/index.vue'
import fpwd from './fpwd/index.vue'
import sgcl from "../../../common/iinv_sjclzx/sgcl/index.vue";
export default {
  name: 'iinv_sjclzx',
  components: {
	  pzwd,
	  fpwd,
    sgcl
  },
  data: function () {
    return {
      chooseindex: 0,
      taballData: [
        {
          label: "凭证维度"
        },
        {
          label: "发票维度"
        },
      ],
      sgclFlag: false,
      sgclParams: {},
      fp_searchdata: {},
      pz_searchdata: {},
    };
  },
  created() {
  },
  methods: {
	  chooseindexs(e){
		  this.chooseindex = e
	  },
    updateSgclFlag(flag) {
      this.sgclFlag = flag;
    },
    setParams(sgclParams) {
      this.sgclParams = sgclParams;
    },
    forback() {
      this.sgclFlag = false;
    },
    setFpSearchdata(searchdata) {
      this.fp_searchdata = searchdata;
    },
    setPzSearchdata(searchdata) {
      this.pz_searchdata = searchdata;
    }
  }
};
</script>


<style scoped lang="less">
@import url('./index.less');
</style>
